<script setup lang="ts">
const props = defineProps<{ to?: string }>()
const router = useRouter()

function goBack() {
  if (props.to) return navigateTo(props.to)
  if (import.meta.client && window.history.length > 1) return router.back()
  return navigateTo('/')
}
</script>

<template>
  <button type="button" class="back" @click="goBack">
    <AppIcon name="chevron-left" :size="20" />
    <span>Back</span>
  </button>
</template>

<style scoped>
.back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border: 0;
  background: none;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: var(--gray-900);
}
</style>
